"use client";

import { useState } from "react";
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWork";
import Benefits from "./components/Benefits";
import TransparentEarnings from "./components/TransparentEarning";
import RegistrationForm from "./components/RegistrationForm";

import ReferralLoginForm from "./RefferalLogin";
import ReferralNavBar from "./referrals-dashboard/ReferralNavBar";
import TawkChat from "./TawkChat";

import ClientExperiences from "./components/ClientDetails";
import ContactSection from "./components/ContactDetails";

export default function ReferralPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [formOpen, setFormOpen] = useState(false);
  const [, setThankYouOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  const handleBecomePartner = () => setFormOpen(true);
  const handleFormSuccess = () => {
    setFormOpen(false);
    setThankYouOpen(true);
  };

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: colors.primary[900] }}>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        {/* Single navbar with partner login built in — no floating Box needed */}
        <ReferralNavBar
          navItems={[
            "Home",
            "How It Works",
            "Benefits",
            "Earnings",
            "Contact Us",
          ]}
          onLoginClick={() => setLoginOpen(true)}
        />
        <TawkChat />

        <HeroSection onBecomePartner={handleBecomePartner} />
        <HowItWorks onBecomePartner={handleBecomePartner} />
        <Benefits onBecomePartner={handleBecomePartner} />
        <TransparentEarnings />
        <ClientExperiences />
        <ContactSection />

        <RegistrationForm
          open={formOpen}
          onClose={() => setFormOpen(false)}
          onSuccess={handleFormSuccess}
        />
        {/* <ThankYouCard open={thankYouOpen} onClose={handleThankYouClose} /> */}
        <ReferralLoginForm
          open={loginOpen}
          onClose={() => setLoginOpen(false)}
        />
      </Box>
    </Box>
  );
}
